import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import {Image as ImageLayer, Tile as TileLayer} from 'ol/layer';
import TileWMS from 'ol/source/TileWMS';
import ImageWMS from 'ol/source/ImageWMS';
import GeoJSON from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {Icon, Fill, Stroke, Style, Text} from 'ol/style';
import Point from 'ol/geom/Point';
import {fromLonLat} from 'ol/proj';
import {defaults as defaultControls, Control, ScaleLine} from 'ol/control';
import OSM from 'ol/source/OSM';

var site_location = "https://zomad.eu/";
var zomad_center = fromLonLat([lon, lat]);

var wmsSource = new ImageWMS({
  attributions: '© 2018-2020 ZOMAD - See <a href="https://zomad.eu/credits">Credits</a>',
  url: 'https://carto.rld.org:8986/geoserver/wms?',
  params: {'LAYERS': 'zomad:iso'},
  //crossOrigin: 'anonymous'
});

var wmsBackground = new TileWMS({
  attributions: '© 2018-2020 ZOMAD - See <a href="https://zomad.eu/credits">Credits</a>',
  url: 'https://carto.rld.org:8981/service?',
  params: {'LAYERS': 'gebco'},
  //crossOrigin: 'anonymous'
});

function geoJsonStyle(feature) {
  var geometryType = feature.getGeometry().getType();

  if(geometryType == "Point") {
    var iconName = feature.get("zid");
    var sImage = new Icon({
        anchor: [20, 60],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        opacity: 1,
        //crossOrigin: 'anonymous',
        src: 'https://data.zomad.eu/img/POI-small/' + iconName + '.png'
      });
    return new Style({
      image: sImage
    });
  } else {
    var sFill = new Fill({
      color: 'rgba(255, 0, 0, 0.4)'
    });
    var sStroke = new Stroke({
      color: '#319FD3',
      lineDash: [2],
      width: 1
    });
    return new Style({
      fill: sFill,
      stroke: sStroke
    });
  }
}

var POI_Layer = new VectorLayer({
  source: new VectorSource({
    url: 'https://data.zomad.eu/geojson/zomad_fr.geojson',
    format: new GeoJSON()
  }),
  style: function(feature) {
    return(geoJsonStyle(feature));
  }
});

var RotateNorthControl = /*@__PURE__*/(function (Control) {
	function RotateNorthControl(opt_options) {
	var options = opt_options || {};
	var br = document.createElement('br');

	var chkL1 = document.createElement('input');
	chkL1.type = "checkbox"; 
	chkL1.id = "chkGEB"; 
	chkL1.checked = true; 
	var labL1 = document.createElement('label');
	labL1.innerHTML = '&nbsp;maritime'; 
	var rangeL1 = document.createElement('input');
	rangeL1.type = "range";
	rangeL1.id = "rngGEB";
	rangeL1.min = 0;
	rangeL1.max = 1;
	rangeL1.step = 0.01;
	rangeL1.value = 0.9;

	var chkL2 = document.createElement('input');
	chkL2.type = "checkbox"; 
	chkL2.id = "chkOSM"; 
	chkL2.checked = true; 
	var labL2 = document.createElement('label');
	labL2.innerHTML = '&nbsp;terrestre'; 
	var rangeL2 = document.createElement('input');
	rangeL2.type = "range";
	rangeL2.id = "rngOSM";
	rangeL2.min = 0;
	rangeL2.max = 1;
	rangeL2.step = 0.01;
	rangeL2.value = 0.4;

	var chkL3 = document.createElement('input');
	chkL3.type = "checkbox"; 
	chkL3.id = "chkZOM"; 
	chkL3.checked = true; 
	var labL3 = document.createElement('label');
	labL3.innerHTML = '&nbsp;ZOMAD'; 

	var element = document.createElement('div');
	element.className = 'rotate-north ol-unselectable ol-control';
	element.appendChild(chkL1);
	element.appendChild(labL1);
	//element.appendChild(br);
	element.appendChild(rangeL1);
	//element.appendChild(br);
	element.appendChild(chkL2);
	element.appendChild(labL2);
	//element.appendChild(br);
	element.appendChild(rangeL2);
	//element.appendChild(br);
	element.appendChild(chkL3);
	element.appendChild(labL3);

		      Control.call(this, {
			            element: element,
			            target: options.target
			          });

		      chkL1.addEventListener('change', this.handleRotateNorth.bind(this), false);
		      rangeL1.addEventListener('change', this.handleRotateNorth.bind(this), false);
		      chkL2.addEventListener('change', this.handleRotateNorth.bind(this), false);
		      rangeL2.addEventListener('change', this.handleRotateNorth.bind(this), false);
		      chkL3.addEventListener('change', this.handleRotateNorth.bind(this), false);
		    }

	  if ( Control ) RotateNorthControl.__proto__ = Control;
	  RotateNorthControl.prototype = Object.create( Control && Control.prototype );
	  RotateNorthControl.prototype.constructor = RotateNorthControl;

	  RotateNorthControl.prototype.handleRotateNorth = function handleRotateNorth () {
		  this.getMap().getLayers().item(0).setVisible (document.getElementById('chkGEB').checked);
		  this.getMap().getLayers().item(0).setOpacity (parseFloat(document.getElementById('rngGEB').value));
		  this.getMap().getLayers().item(1).setVisible (document.getElementById('chkOSM').checked);
		  this.getMap().getLayers().item(1).setOpacity (parseFloat(document.getElementById('rngOSM').value));
		  this.getMap().getLayers().item(2).setVisible (document.getElementById('chkZOM').checked);
		  this.getMap().getLayers().item(3).setVisible (document.getElementById('chkZOM').checked);
		    };

	  return RotateNorthControl;
}(Control));

var layers = [

	new TileLayer({
		source: wmsBackground,
		opacity: 0.9
        }),
	new TileLayer({
		source: new OSM({
		  attributions: '© 2018-2020 ZOMAD - See <a href="https://zomad.eu/credits">Credits</a>'
			}),
		opacity: 0.4
        }),
	new ImageLayer({
		source: wmsSource
	}),

	POI_Layer
];

var view = new View({
  center: zomad_center,
  zoom: zoom,
  minZoom: 1,
  maxZoom: 18
});

var map = new Map({
  controls: defaultControls().extend([
    new ScaleLine({
      units: 'nautical'
    }),
    new RotateNorthControl()
  ]),
  layers: layers,
  target: 'map',
  view: view
});

var info = $('#info');
info.tooltip({
  animation: false,
  trigger: 'manual'
});

var displayFeatureInfo = function(pixel) {
  info.css({
    left: pixel[0] + 'px',
    top: (pixel[1] - 15) + 'px'
  });
  var feature = map.forEachFeatureAtPixel(pixel, function(feature) {
    return feature;
  });
  if (feature) {
    if(feature.get("zclic") == 'yes') {
      var zclass = 'glyphicon glyphicon-file';
    } else {
      var zclass = 'glyphicon glyphicon-zoom-in';
    }
    var txt = '<div class="' + zclass + '"></div>&nbsp;';
    txt += '<b>' + feature.get('zcnt') + '</b>';
    txt += '</br>';
    txt += feature.get('zdesc');
    info.tooltip('hide')
      .attr('data-original-title', txt)
      .tooltip('fixTitle')
      .tooltip('show');
  } else {
    info.tooltip('hide');
  }
};

var clickOnFeature = function(pixel) {
  var feature = map.forEachFeatureAtPixel(pixel, function(feature) {
    return feature;
  });
  if (feature) {
    if(feature.get("zclic") == 'yes') {
      var lowzid = (feature.get("zid")).toLowerCase();
      window.location.href = site_location + lowzid;
    } else {
      var coord = feature.getGeometry().getCoordinates();
      var newzoom = map.getView().getZoom() + 2;
      view.animate({
        center: coord,
        zoom: newzoom,
        duration: 700
      });

      //map.getView().setZoom(map.getView().getZoom() + 1);
      //map.getView().setCenter(coord);
    }
  }
};

map.on('pointermove', function(evt) {
  if (evt.dragging) {
    info.tooltip('hide');
    return;
  }
  displayFeatureInfo(map.getEventPixel(evt.originalEvent));
});

map.on('click', function(evt) {
  clickOnFeature(evt.pixel);
});


/*
map.on('singleclick', function(evt) {
  document.getElementById('info').innerHTML = '';
  var viewResolution = (view.getResolution());
  var url = wmsSource.getFeatureInfoUrl(
    evt.coordinate, viewResolution, 'EPSG:3857',
    {'INFO_FORMAT': 'text/html'});
  if (url) {
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        document.getElementById('info').innerHTML = html;
      });
  }
});

map.on('pointermove', function(evt) {
  if (evt.dragging) {
    return;
  }
  var pixel = map.getEventPixel(evt.originalEvent);
  var hit = map.forEachLayerAtPixel(pixel, function() {
    return true;
  });
  map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});
*/

